import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import './iframe-payment.css';

const IframePayment = ({ url, openModal = false, OnCloseModal, props }) => {
  return (
    <div>
      <Modal
        open={openModal}
        onClose={OnCloseModal}
        center
        closeOnEsc={false}
        closeOnOverlayClick={false}
        showCloseIcon={false}
      >
        {openModal && (
          <iframe src={url} title='conf' frameBorder='0' style={{ overflow: 'hidden', height: '100%', width: '100%' }} height='100%' width='100%' />
        )}
      </Modal>
    </div>
  );
};

export default IframePayment;
